import { createSelector } from 'reselect';
import _values from 'lodash/values';

const selectedGuests = state => state.selectedGuests;
const guestSearchSet = state => state.guestSearchSet;

export const getByEventId = (state, eventId) => {
  if (state != null && state.byEventId != null) {
    return state.byEventId[eventId];
  }
  return null;
};

export const getChartByEventId = createSelector(getByEventId, seatingCharts => {
  if (seatingCharts == null || seatingCharts.length === 0) {
    return null;
  }
  // For now, just use the first chart available by event id. (There will eventually be more than one once drafts are used)
  return seatingCharts[0];
});

export const getTables = state => {
  const tables = _values(state.tablesByUUID);
  return tables.length > 0 ? tables : [];
};

export const getTotalNumberOfSeats = createSelector(getTables, tables =>
  tables.reduce((total, table) => total + table.num_seats, 0)
);

export const getTablesOfSelectedGuests = createSelector(
  selectedGuests,
  guestSearchSet,
  (selected, guests) => {
    const keys = selected.guests.concat(selected.couple);
    return keys.map(key => guests[key].tableUUID);
  }
);



// WEBPACK FOOTER //
// ./src/selectors/seatingchart/SeatingChartSelector.js